import * as Colors from '../../constants/Colors';
import { SvgIconProps } from '../IconProps';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type HeartIconProps = SvgIconProps & {
    color?: string;
};

export const HeartIcon = ({ color, ...props }: HeartIconProps) => (
    <BaseSvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M4.09188 11.1344L12 20L19.9081 11.1344C21.364 9.50234 21.364 6.85618 19.9081 5.22408C18.4523 3.59197 16.0919 3.59197 14.636 5.22408L12 8.17926L9.36396 5.22408C7.90812 3.59197 5.54773 3.59197 4.09188 5.22408C2.63604 6.85618 2.63604 9.50234 4.09188 11.1344Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </BaseSvgIcon>
);

HeartIcon.defaultProps = {
    color: Colors.black,
    height: '24px',
    width: '24px',
};
